<template>
  <div class="backgroundClass">
    <div class="loginBox">
      <!-- <img class="logo-wrap" src="/static/LogoTest.png" alt="Mountain View"> -->
      <h2>Nulstil din adgangskode</h2>
      <div class="contentText">
        Skriv din email, så sender vi et link som du kan bruge til at ændre din adgangskode.
      </div>
      <input v-model="email" placeholder="E-mail" type="email" >
      <button type="button" v-on:click="resetPassword" :disabled="disabledActive">Send link</button>


      <router-link class="loginLink" to="/login">Cancel</router-link>
    </div>
    <transition name="fade">
      <info-modal v-if="showModal" @close="showModal = false">
        <div slot="body">{{modalInfoText}}</div>
      </info-modal>
    </transition>
  </div>
</template>

<script>
import infoModal from '@/components/infoModal.vue'
import { app } from '@/firebase'
export default {
  data () {
    return {
      email: '',
      disabledActive: false,
      showModal: false,
      modalInfoText: '',
    }
  },
  components: {
    'info-modal': infoModal
  },
  methods: {
    resetPassword: function() {
      this.disabledActive = true
      var self = this
      app.auth().sendPasswordResetEmail(this.email).then(function() {
        self.modalInfoText = 'Vi har sendt et link til din email'
        self.showModal = true
        self.email = ''
        self.disabledActive = false
      }).catch(function(error) {
        var errorCode = error.code;
        if (errorCode == 'auth/invalid-email') {
          self.modalInfoText = 'Ugyldig email'
        } else if (errorCode == 'auth/user-not-found') {
          self.modalInfoText = 'Der findes ingen bruger med den email'
        } else {
          self.modalInfoText = 'Ooops!'
        }
        self.showModal = true
        self.disabledActive = false
      });
    }
  },
  created(){
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

h2 {
  margin-top: 0px;
  margin-bottom: 10px;
}
input {
  margin: 6px 0;
  width: 100%;
  /* background-color: #f3f2ee; */
  /* border: 1px solid #e8e7e3; */
  border: 0px;
  border-radius: 4px;
  background-color: white;
  font-size: 16px;
  padding: 7px 18px;
  height: 40px;
  margin-top: 40px;
}

input:focus {
  outline: none;
}


.backgroundClass {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(rgba(0, 186, 224, 1), rgba(0, 186, 224, 0.5));
}

.loginBox {
  border-radius: 4px;
  width: 300px;
  height: 300px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.loginLink {
  position: absolute;
  bottom: 5px;
  right: 5px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
}

button {
  width: 130px;
  margin-top: 40px;
  padding: 10px 20px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.6);
  border: 0;
  font-weight: 400;
  background-color: white;
  border-radius: 4px;
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.3);
}

.logo-wrap {
  display: block;
  width: 100%;
  margin-bottom: 30px;
}

.contentText {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/resetPassword.vue